import React from 'react'
import useTranslation from '../hooks/useTranslation'

const Booking = () => {
  const { t } = useTranslation()

  return (
    <div style={{ paddingTop: '120px' }}>
      <section>
        <div className="container">
          <h2>{t('booking.title')}</h2>

          <div style={{
            maxWidth: '800px',
            margin: '0 auto 40px auto',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
            backgroundColor: '#111',
            borderRadius: '4px',
            padding: '40px',
            textAlign: 'center'
          }}>
            <h3 style={{ marginBottom: '30px' }}>{t('booking.contactHeading')}</h3>

            <div style={{ marginBottom: '30px' }}>
              <p style={{ fontSize: '1.2rem', marginBottom: '20px' }}>
                {t('booking.contactText')}
              </p>

              <a
                href="https://www.instagram.com/ayite__/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '15px 30px',
                  backgroundColor: '#222',
                  color: '#fff',
                  textDecoration: 'none',
                  borderRadius: '25px',
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '10px' }}>
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
                @ayite__
              </a>
            </div>

            <div style={{ marginTop: '40px', padding: '20px', backgroundColor: '#222', borderRadius: '4px' }}>
              <h4 style={{ marginBottom: '15px' }}>{t('booking.alternativeHeading')}</h4>
              <p style={{ marginBottom: '10px' }}>{t('booking.alternativeText')}</p>
              <a
                href="mailto:bookings@ayite.de"
                style={{
                  color: 'white',
                  textDecoration: 'underline',
                  fontWeight: 'bold'
                }}
              >
                bookings@ayite.de
              </a>
            </div>

            <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#111', borderRadius: '4px', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
              <h4 style={{ marginBottom: '15px' }}>{t('booking.pressKitHeading')}</h4>
              <p style={{ marginBottom: '20px' }}>{t('booking.pressKitText')}</p>
              <a
                href="https://epk.ayite.de/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '12px 24px',
                  backgroundColor: '#fff',
                  color: '#000',
                  textDecoration: 'none',
                  borderRadius: '25px',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  transition: 'all 0.3s ease'
                }}
              >
                {t('booking.viewPressKit')}
              </a>
            </div>

            <div style={{ marginTop: '40px' }}>
              <p>{t('booking.requestInfo')}</p>
              <ul style={{
                listStyle: 'none',
                textAlign: 'left',
                maxWidth: '400px',
                margin: '20px auto',
                padding: '0'
              }}>
                <li style={{ marginBottom: '10px', padding: '10px', backgroundColor: 'rgba(255,255,255,0.05)' }}>• {t('booking.eventDate')}</li>
                <li style={{ marginBottom: '10px', padding: '10px', backgroundColor: 'rgba(255,255,255,0.05)' }}>• {t('booking.venueLocation')}</li>
                <li style={{ marginBottom: '10px', padding: '10px', backgroundColor: 'rgba(255,255,255,0.05)' }}>• {t('booking.eventType')}</li>
                <li style={{ marginBottom: '10px', padding: '10px', backgroundColor: 'rgba(255,255,255,0.05)' }}>• {t('booking.setDuration')}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Booking
